import { createSelector } from "reselect"

export const currentUserSelector = state => (state.current_user ? state.current_user : {})

export const analyticsSelector = createSelector(currentUserSelector, currentUser =>
    currentUser.analytics_dashboards ? currentUser.analytics_dashboards : []
)
